const AUTH_REDIRECT = import.meta.env.VITE_API_URL_AUTH_REDIRECT;

export const msalConfig = {
  auth: {
    clientId: "afc08497-9e62-45a7-ad4d-964ca0bfd66c", // Replace with your Azure AD application client ID
    authority:
      "https://login.microsoftonline.com/acb40161-aec8-4888-a742-8c17640241e6", // Replace with your tenant ID
    redirectUri: `${AUTH_REDIRECT}`,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"],
};

// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
